import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { isEmpty } from 'helpers/verify';
import { DefineVariables } from 'providers/ContextVariables';
import { CallToAction, ACTIONS } from 'components/CallToAction';
import { CmsModuleShape } from 'containers/CmsPage/CmsModules';
import { ProductCard } from './cards/ProductCard';
import { SignupCard } from './cards/SignupCard';

export class ProductGroup extends Component {
  constructor(...args) {
    super(...args);
    this.CARD_RENDERER_BY_TYPE = {
      productcard: this.renderProductCard.bind(this),
      signupcard: this.renderSignupCard.bind(this),
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.msaId !== prevProps.msaId) {
      this.props.loadCardData({
        productType: this.props.productType,
        productCode: this.props.productCode,
      });
    }
  }

  updateCardWithCmsOverrides() {
    // Deep clone card prop to avoid mutating the original
    let card = JSON.parse(JSON.stringify(this.props.card));
    const [offer] = card.offers || [{}];
    const finalProperties = {};
    const propertyList = ['callout', 'calloutNote', 'ctaCopy', 'details', 'disclaimer', 'modules', 'tag', 'url'];

    const updatedProperties = propertyList.reduce((acc, property) => {
      // Give preference to CMS overrides
      acc[property] = this.props[property] || offer[property];
      return acc;
    }, finalProperties);
    // Overwrite the original offer on the card with any updates
    card = Object.assign(card, updatedProperties);
    return card;
  }

  selectCardRenderer(type) {
    const normalizedType = (type || '').toLowerCase();
    return this.CARD_RENDERER_BY_TYPE[normalizedType] || this.CARD_RENDERER_BY_TYPE.productcard;
  }

  renderProductCard() {
    const { cmsModuleId, showMultipleOffers, checkFirstOfferByDefault = true } = this.props;
    let { card } = this.props;
    card = this.updateCardWithCmsOverrides();

    const cta = card.ctaCopy && card.url && (
      <CallToAction action={ACTIONS.LINK} color="primary_solid" extraClass="bt--lg bt--width-full" to={card.url}>
        {card.ctaCopy}
      </CallToAction>
    );

    return (
      <ProductCard
        {...card}
        cta={cta}
        cmsModuleId={cmsModuleId}
        showMultipleOffers={showMultipleOffers}
        checkFirstOfferByDefault={checkFirstOfferByDefault}
      />
    );
  }

  renderSignupCard() {
    const { cmsModuleId, showMultipleOffers, checkFirstOfferByDefault = false } = this.props;
    let { card } = this.props;
    card = this.updateCardWithCmsOverrides();
    return (
      <SignupCard
        {...card}
        cmsModuleId={cmsModuleId}
        showMultipleOffers={showMultipleOffers}
        checkFirstOfferByDefault={checkFirstOfferByDefault}
      />
    );
  }

  render() {
    const { card, cardType, disclaimer, msaId } = this.props;

    if (isEmpty(card)) {
      return null;
    }

    const Card = this.selectCardRenderer(cardType);

    return (
      <div className="ProductGroup">
        <div className="ProductGroup__cards">
          <DefineVariables variables={card?.offers?.[0]?.contextVariables}>
            <Card key={msaId} />
          </DefineVariables>
        </div>
        {disclaimer && <p className="ProductGroup__disclaimer">{disclaimer}</p>}
      </div>
    );
  }
}

ProductGroup.propTypes = {
  callout: PropTypes.string,
  calloutNote: PropTypes.string,
  card: PropTypes.object,
  cardType: PropTypes.string,
  checkFirstOfferByDefault: PropTypes.bool,
  cmsModuleId: PropTypes.string.isRequired,
  ctaCopy: PropTypes.string,
  details: PropTypes.string,
  disclaimer: PropTypes.node,
  loadCardData: PropTypes.func.isRequired,
  hasEmbeddedSignup: PropTypes.bool,
  modules: PropTypes.arrayOf(CmsModuleShape),
  msaId: PropTypes.number,
  productCode: PropTypes.string,
  productType: PropTypes.string,
  showMultipleOffers: PropTypes.bool,
  tag: PropTypes.string,
  url: PropTypes.string,
};
